<template src="./index.html"></template>
<script>
import {getdata} from "./data.js";
import minhead from "../../../../common/minHead/index.vue";
import updateywkm from "../../../../common/updateywkm/index.vue";
import config from "../../../../../../configHttp.js";
import {
  getMappingPageListByRule,
  getDetailById,
  saveMapping,
  updateMapping,
  importMapping,
  clearMapping,
  queryCompanySz
} from "../../../../../api/home.js";
import uploadFile from "../../../../common/uploadFile/index.vue";
export default {
  name: "",
  components: {
    minhead,
    updateywkm,
    uploadFile,
  },
  data() {
    return {
      tablekey: 0,
      searchdata: getdata().searchdata,
      searchlist: getdata().searchlist,
      searchdiag: false,
      outlist: [],
      headData: getdata().headData,
      pagination: getdata().pagination,
      sort: "",
      order: "",
      tableData: [],
      shaidiag: false,
      ywdiag: false,
      ywtitle: "",
      mapping: {},
      relations: [],
	  isNo:false,
      filediag: false,
      upformdata: {},
      sourceFlagData:[],
	  Szlist:[]
    };
  },
  props: {
    id: {
      type: String,
      default: "",
    },
    ruleNum: {
      type: String,
      default: "",
    },
	ywdiags: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
	ywdiags:function(indexVal, oldVal) {
		if(indexVal == true){
			this.getMappingPageListByRule();
		}else{
			Object.keys(this.searchdata).map(key=>{
				this.searchdata[key] = ''
			})
		}
    },
  },
  created() {
	  this.queryCompanySz()
  },
  mounted() {
	 
  },
  methods: {
	  selectchange(e){
		  if(e.prop=="declareType"){
			  this.Szlist.forEach(item=>{
			  	if(e.value==item.shuizId){
					this.searchdata.reportId=''
					this.searchlist.forEach(gtem=>{
						if(gtem.prop=="reportId"){
							gtem.disabled=false
							gtem.selectval=item.children.map(ytem=>{
								return{
									label:ytem.reportName,
									value:ytem.shuibId
								}
							})
						}
					})
			  	}
			  })
			  let newarr= JSON.parse(JSON.stringify(this.searchlist))
			  this.searchlist=newarr
		  }
	  },
	  resetClickFun(){
		 this.searchlist =getdata().searchlist
	  },
	  //获取税种和报表名称
	  queryCompanySz(){
	  	queryCompanySz().then(res=>{
	  		if(res.data.code=1){
	  			this.Szlist=res.data.data
			
	  		}
	  	})
	  },
	 
    cleanYs() {
      var chooseitem = this.$refs.tablebox.getSelectionval();
      if(this.$emptyandnull(chooseitem)){
        this.$message.warning("请先进行列表勾选");
        return;
      }
      clearMapping({
        ids: chooseitem.map((item) => item.id).join(","),
      }).then((res) => {
        if ((res.data.code == 1)) {
          this.$message.success("清除成功");
          this.getMappingPageListByRule();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    forupload() {
      if (this.$emptyandnull(this.upformdata.upfile)) {
        this.$message.error("请选择要上传的文件");
        return false;
      }
      let formData = {
        ruleId: this.id,
        file: this.upformdata.upfile,
      };
      importMapping(formData).then((res) => {
        if ((res.data.code == 1)) {
          if (res.data.data.errorCount > 0) {
            this.$message.error(res.data.data.errorMessage.join(","));
          } else {
            this.$message.success("上传成功");
          }

          this.getMappingPageListByRule();
          this.filediag = false;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    getuploadparams(e) {
      //获取上传文件流
      this.upformdata = e;
    },

    formbdr() {
      this.upformdata = {
        upfilename: "",
        upfile: "",
        filestate: "",
        filetype: "",
        filesize: "",
      };
      this.filediag = true;
    },
    /* 新增/编辑 */
    closediag() {
      this.ywdiag = false;
    },
    getywkmForm(data) {
      //对业务科目公式计算逻辑判断：
      let subjectCodeArr = [];
      let formula = data.mapping.formula
      // if (data.mapping.sourceFlag == '1') {
      //   subjectCodeArr.push(data.mapping.companySubjectCode);
      //   formula = "(" + data.mapping.companySubjectCode + ")";
      //   if (data.relations.length > 0) {
      //     for (let i = 0; i < data.relations.length; i++) {
      //       let relation = data.relations[i];
      //       formula += relation.formula;
      //       formula += "(" + relation.companySubjectCode + ")";
      //       subjectCodeArr.push(relation.companySubjectCode);
      //     }
      //   }
      // }
      data.mapping.formula = formula;
      data.mapping.subjectCodes = subjectCodeArr.join(",");
      if (this.ywtitle == "新增业务科目") {
        data.mapping.ruleNum = this.ruleNum;
        data.mapping.ruleId = this.id;
        saveMapping(data).then((res) => {
          if (res.data.code == 1) {
            this.$message.success("新增成功!"+res.data.msg);
            this.ywdiag = false;
            this.getMappingPageListByRule();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      } else {
        updateMapping(data).then((res) => {
          if (res.data.code == 1) {
            this.$message.success("编辑成功!"+res.data.msg);
            this.ywdiag = false;
            this.relations = [];
            this.getMappingPageListByRule();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }
    },
    forupdateywkm(row,item) {
      getDetailById({
        id: row.id,
      }).then((res) => {
        if (res.data.code == 1) {
          this.relations = res.data.data.relations;
          this.mapping = res.data.data.mapping;
          if (!this.mapping.isCurrentPeriod) {
            this.mapping.isCurrentPeriod = "0";
          }
		  if(item){
			  this.ywtitle = "查看业务科目";
			  this.isNo = true
		  }else{
			  this.ywtitle = "编辑业务科目";
			  this.isNo = false
		  }
          this.ywdiag = true;
          let sourceArr = JSON.parse(JSON.stringify(this.$sourceFlagMapping));
          sourceArr.map((item,index)=>{
            if(item.value === '5' && this.mapping.sourceFlag != '5')
              sourceArr.splice(index,1);
          });
          this.sourceFlagData = sourceArr;
        }
      });
    },
    foraddywkm() {
      this.mapping = {isCurrentPeriod: '0'};
      this.ywtitle = "新增业务科目";
      this.relation = [];
      this.sourceFlagData = this.$sourceFlagMapping;
      this.ywdiag = true;
    },
    /* 新增/编辑 */
    /* 表格 */
    sortchange(data) {
      this.sort = data.prop;
      this.order = data.order == "ascending" ? "asc" : "desc";
      this.getMappingPageListByRule();
    },
    sizechange(e) {
      this.pagination.pageSize = e;
      this.getMappingPageListByRule();
    },
    currentChange(e) {
      this.pagination.pageNum = e;
      this.getMappingPageListByRule();
    },
    submitSearch() {
      this.pagination.pageNum = 1;
      this.pagination.paginationkey++;
      this.getMappingPageListByRule();
    },
    getMappingPageListByRule() {
      let params = JSON.parse(JSON.stringify(this.searchdata));
      params.ruleId = this.id;
      params.current = this.pagination.pageNum;
      params.size = this.pagination.pageSize;
      params.sort = this.sort;
      params.order = this.order;
      getMappingPageListByRule(params).then((res) => {
        this.pagination.total = res.data.data.total;
        this.tableData = res.data.data.records;
      });
    },
    /* 表格 */
    /* 搜索筛选 */
    forUpdateSearch() {
      this.searchdiag = true;
    },
    closeSearch() {
      this.searchdiag = false;
    },
    saveChange(e) {
      this.searchdiag = false;
    },
    confirmfilter(e) {
      this.headData = e.chooselist;
      this.outlist = e.nochooselist;
      this.shaidiag = false;
    },
    closeshaidiag() {
      this.shaidiag = false;
    },
    /* 搜索筛选 */
    //返回
    forback() {
		
      this.$emit("forback", false);
    },
    exportExcel() {
       //得到勾选的列表值：
      var chooseitem = this.$refs.tablebox.getSelectionval();
      if(!this.$emptyandnull(chooseitem)){
          this.searchdata.ids = chooseitem.map((item) => item.id).join(",")
      }
      this.searchdata.ruleId = this.id;
      let params = {
        downUrl: config.baseURL + "/mapping/exportExcel",
        typeObj: {
          toForm: true,
          fileType: "xlsx",
          failUrl:this.$winURl
        },
        params: JSON.parse(JSON.stringify(this.searchdata)),
      };
      this.$downloadcommon(params);
    },
    //下载标准模板
    fordownloadmb() {
      //简单下载，交给浏览器去做处理
       let params = {
        downUrl: config.baseURL + "/mapping/dowloadTemplate",
        typeObj: {
          toForm: true,
          fileType: "xlsx",
          failUrl:this.$winURl
        },
        params:{},
      };
      this.$downloadcommon(params);
    },
  },
};
</script>
<style scoped lang="less">
@import url('./index.less');
</style>
